export const PAST_DAYS_VALUES = [15, 30, 60] as const
export const DEFAULT_PAST_DAYS_VALUE = PAST_DAYS_VALUES[1]
